import { FormControl, FormHelperText, TextField, Typography } from "@mui/material"
import { getDistanceUnitTitle } from "form/tools/geo-targets"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IFieldDistanceProps {
  id: string
  label: string
  error?: string
  disabled?: boolean
  required?: boolean
  placeholder?: string
  value: string | null
  sx?: any
  onChange: (distance: string | null) => any
  onEnterKey?: () => any
  onBlur?: () => any
}

export const FieldDistance = React.memo(
  ({
    id,
    error,
    label,
    disabled,
    required,
    placeholder,
    value,
    onChange,
    onEnterKey,
    onBlur,
    sx
  }: IFieldDistanceProps) => {
    const hasError = !!error
    const onKeyUp = (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (!onEnterKey) {
        return
      }
      event.stopPropagation()
      event.preventDefault()
      if (event.key === "Enter" && !hasError) {
        onEnterKey()
      }
    }
    return (
      <FormControl
        error={hasError}
        sx={{
          "& fieldset": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderLeft: "none"
          },
          "& input::placeholder": { fontSize: ".7rem" },
          ...sx
        }}>
        <FlexBox>
          <FlexBox
            sx={{
              backgroundColor: theme => theme.palette.form,
              opacity: disabled ? 0.6 : 1,
              pl: ".5rem",
              pr: ".5rem",
              borderTopLeftRadius: ".25rem",
              borderBottomLeftRadius: ".25rem",
              height: "2.5rem",
              transition: "opacity 400ms ease"
            }}>
            <Typography
              sx={{
                color: theme => theme.palette.formText,
                fontSize: ".8rem"
              }}>
              {getDistanceUnitTitle()}
            </Typography>
          </FlexBox>
          <TextField
            id={id}
            variant="outlined"
            error={hasError}
            required={required}
            label={label}
            size="small"
            value={value === null ? "" : value}
            type="number"
            placeholder={placeholder}
            onChange={event => onChange(event.target.value !== "" ? event.target.value : null)}
            onBlur={() => (onBlur ? onBlur() : undefined)}
            disabled={disabled}
            onKeyUp={onEnterKey ? event => onKeyUp(event) : undefined}
            sx={{ width: "100%" }}
          />
        </FlexBox>
        {hasError && <FormHelperText id={`${id}-error`}>{error}</FormHelperText>}
      </FormControl>
    )
  }
)
